<div *ngIf="isCrack == 1 && SchematicOP != undefined">
  <div class="image-wrapper">
    <img #image class="schematicImage" [src]="sanitize(schematicData.Data)" (click)="openSchematicWindow(schematicData,0)" title="View expanded schematic with component type mapping and observation points">
    <!--<img class="schematicImage" [src]="schematicData.ImageUrl" (click)="openSchematicWindow(schematicData,0)">-->
    <!-- <canvas #canvas></canvas> -->
  </div>
  <ng-container *ngFor="let cp of SchematicOP">
    <ng-container *ngIf="cp.Eval == ''">
      <i class="material-icons button__icon component-dot" *ngIf="cp.ObPointTypeId != 2"
         [class.green-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'green'"
         [class.yellow-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'yellow'"
         [class.orange-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'orange'"
         [class.red-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'red'"
         [class.no-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'gray'"
         [class.component-dot2]="mouseoverOPId == cp.Id"
         matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
         [style]="getPosition(cp.PositionX, cp.PositionY)"
         (mouseenter)="onMouseEnter(cp.Id)"
         (mouseleave)="onMouseEnter(0)"
         (click)="onMouseClick(cp.Id)"
         [ngClass]="{ 'highlightobspoint': selectedObsPointId == cp.Id }">lens</i>

      <i class="material-icons button__icon component-dot" *ngIf="cp.EndPositionX!=null && cp.ObPointTypeId != 2"
         [class.green-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'green'"
         [class.yellow-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'yellow'"
         [class.orange-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'orange'"
         [class.red-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'red'"
         [class.no-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'gray'"
         [class.component-dot2]="mouseoverOPId == cp.Id"
         matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.EndPositionX}},{{cp.EndPositionY}}"
         [style]="getPosition(cp.EndPositionX, cp.EndPositionY)"
         (mouseenter)="onMouseEnter(cp.Id)"
         (mouseleave)="onMouseEnter(0)"
         (click)="onMouseClick(cp.Id)"
         [ngClass]="{ 'highlightobspoint': selectedObsPointId == cp.Id }">lens</i>

      <div *ngIf="cp.EndPositionX!=null"  
            [class.component-dot2]="mouseoverOPId == cp.Id" 
            [class.yellow-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'yellow'"
            (mouseenter)="onMouseEnter(cp.Id)" 
            (mouseleave)="onMouseEnter(0)"
            matTooltip="{{cp.Name}} - Crack Date {{cp.InstallDate}} - Current Length {{cp.CurrentLength}} {{userUOM}} - Crack Status {{cp.CrackStatus}}
                          {{cp.CrackSeverity != null ? ' - Severity ' + cp.CrackSeverity : ''}} -  {{ cp.CrackStatusId === 1 ? '' : ' - (' + cp.WornPct + '% Worn)' }}"
            [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed, cp)"></div>
    </ng-container>
    <ng-container *ngIf="cp.Eval != ''">
      <i class="material-icons button__icon component-dot"
         [class.green-eval]="cp.Eval == 'A'"
         [class.yellow-eval]="cp.Eval == 'B'"
         [class.orange-eval]="cp.Eval == 'C'"
         [class.red-eval]="cp.Eval == 'X'"
         [class.no-eval]="cp.Eval == 'U'"
         [class.component-dot2]="mouseoverOPId == cp.Id"
         matTooltip="{{cp.Name}} (Eval - {{cp.Eval}}) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
         [style]="getPosition(cp.PositionX, cp.PositionY)"
         (mouseenter)="onMouseEnter(cp.Id)"
         (mouseleave)="onMouseEnter(0)"
         (click)="onMouseClick(cp.Id)"
         [ngClass]="{ 'highlightobspoint': selectedObsPointId == cp.Id }">lens</i>
    </ng-container>

  </ng-container>
</div>

<div *ngIf="isCrack == 2">
  <img class="schematicImage" [src]="sanitize(schematicData.Data)" (click)="openSchematicWindow(schematicData,1)">

  <ng-container *ngFor="let cp of SchematicOP">
    <ng-container *ngIf="cp.Type == 'Crack'">
      <ng-container *ngIf="cp.Eval == ''">
        <i class="material-icons button__icon component-dot" *ngIf="cp.ObPointTypeId != 2"
           [class.green-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'green'"
           [class.yellow-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'yellow'"
           [class.orange-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'orange'"
           [class.red-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'red'"
           [class.no-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'gray'"
           [class.component-dot2]="mouseoverOPId == cp.Id"
           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>

        <i class="material-icons button__icon component-dot" *ngIf="cp.EndPositionX!=null && cp.ObPointTypeId != 2"
           [class.green-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'green'"
           [class.yellow-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'yellow'"
           [class.orange-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'orange'"
           [class.red-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'red'"
           [class.no-eval]="getEval(cp.WornPct, cp.LastInspectionDate) == 'gray'"
           [class.component-dot2]="mouseoverOPId == cp.Id"
           matTooltip="{{cp.Name}} ({{cp.WornPct}}% Worn) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.EndPositionX}},{{cp.EndPositionY}}"
           [style]="getPosition(cp.EndPositionX, cp.EndPositionY)">lens</i>

        <div *ngIf="cp.EndPositionX!=null" 
        matTooltip="{{cp.Name}} - Crack Date {{cp.InstallDate}} - Current Length {{cp.CurrentLength}} {{userUOM}} - Crack Status {{cp.CrackStatus}}
                           {{cp.CrackSeverity != null ? ' - Severity ' + cp.CrackSeverity : ''}} - {{ cp.CrackStatusId === 1 ? '' : ' - (' + cp.WornPct + '% Worn)' }}"
        [style]="getLine(cp.PositionX, cp.PositionY,cp.EndPositionX, cp.EndPositionY,cp.IsCrackFixed, cp)"></div>
      </ng-container>
      <ng-container *ngIf="cp.Eval != ''">
        <i class="material-icons button__icon component-dot"
           [class.green-eval]="cp.Eval == 'A'"
           [class.yellow-eval]="cp.Eval == 'B'"
           [class.orange-eval]="cp.Eval == 'C'"
           [class.red-eval]="cp.Eval == 'X'"
           [class.no-eval]="cp.Eval == 'U'"
           [class.component-dot2]="mouseoverOPId == cp.Id"
           matTooltip="{{cp.Name}} (Eval - {{cp.Eval}}) Last Inspection - {{cp.LastInspectionDate}} X,Y coord: {{cp.PositionX}},{{cp.PositionY}}"
           [style]="getPosition(cp.PositionX, cp.PositionY)">lens</i>
      </ng-container>

    </ng-container>
  </ng-container>
</div>

<!-- (mouseover)="onMouseOverOP(cp.Id)"
(mouseout)="onMouseOutOP(cp.Id)" -->

<schemantic-op-popup *ngIf="showSchematic" [(positionX)]="schematicPositionX" [(positionY)]="schematicPositionY"
                     [(currentStep)]="currentStep" [(mouseoverMPId)]="mouseoverMPId" [(mouseoverOPId)]="mouseoverOPId"
                     [(CustomerId)]="selectedCustomer" [(ImplementId)]="ImplementId" (mouseoverMP)="onMouseOverMP($event)"
                     (mouseoverOP)="onMouseOverOP($event)" [schematic]="selectedSchematic"
                     (closeSchematicWindow)="onCloseSchematicWindow($event);" (saveObservation)="onSaveObservation($event)"
                     [(title)]="draggableSchematicTitle" [(isTemplate)]="isTemplate" [(userUOM)]="userUOM"></schemantic-op-popup>
